<!-- eslint-disable vue/multi-word-component-names -->
<script>
import AppDatePicker from '@/components/app/DatePicker.vue';
export default {
  name: 'QCDashboardFilterModal',
  components: {
    AppDatePicker,
  },
  props: {
    isModalOpen: {
      type: Boolean,
      required: true,
      default: false,
    },
    defaultFields: {
      type: Object,
      required: true,
      default: () => { },
    },
  },
  data() {
    return {
      toDate: '',
      fromDate: '',
      // currentDate: new Date().toISOString()?.split('Z')[0],
      currentDate: new Date()
        .toLocaleString("sv-SE")
        .replace(" ", "T")
    };
  },
  mounted() { },
  methods: {
    setFilter: function () {
      const fromDate = this.fromDate
        ? this.fromDate
        : `${this.currentDate?.split('T')[0]}T00:00:00`;
      const toDate = this.toDate ? this.toDate : this.currentDate;
      this.$emit('set-filter', fromDate, toDate);
    },
    // setInitialFilter:function(){
    //   this.fromDate=this.defaultFields.fromDate;
    //   this.toDate=this.defaultFields.toDate
    // }
  },
};
</script>
<template>
  <v-dialog width="350" :value="isModalOpen">
    <v-card>
      <v-row no-gutters>
        <v-col cols="12" class="modal-header py-2">
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <v-icon color="darkColor">mdi-magnify</v-icon>
            <span class="modal-title-text mr-n3">جستجو</span>
            <v-spacer></v-spacer>
          </v-row>
        </v-col>
      </v-row>
      <v-card-text class="mt-12">
        <v-row>
          <v-col cols="12">
            <app-date-picker dense inputID="fromDate" label="تاریخ شروع" :input-value="defaultFields.fromDate"
              v-model="fromDate" />
          </v-col>
          <v-col cols="12">
            <app-date-picker dense inputID="toDate" label="تاریخ پایان" :input-value="defaultFields.toDate"
              v-model="toDate" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="mt-2">
        <v-spacer></v-spacer>
        <v-btn color="darkColor" @click="setFilter" dark rounded class="normal-letter-spacing px-12">
          جستجو
        </v-btn>
        <v-btn rounded color="darkColor" outlined @click="$emit('close-modal')" class="normal-letter-spacing px-10">
          انصراف
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
